<ng-container *transloco="let t">
  <!-- Component -->
  <section
    class="popsy-text-field"
    dir="ltr"
    [class.error]="error && initialized"
    [class.rtl]="rtlLayout$ | async"
    *ngIf="loading !== true">
    <label class="label" [for]="id || generatedId" *ngIf="label">
      <ng-container *ngIf="required">
        <strong class="required-indicator">*</strong>
        <span class="fixed-space-4" aria-hidden="true"></span>
      </ng-container>
      {{ label }}
    </label>
    <div
      class="flex flex-row align-center justify-center inputs"
      [class.rtl]="rtlLayout$ | async">
      <div #countryCodeBtn class="phone-preview">
        <ng-container *ngIf="countryFormControl.value?.flag">
          <img
            class="flag"
            [alt]="countryFormControl.value?.display"
            aria-hidden="true"
            [src]="countryFormControl.value?.flag"
            width="25"
            height="25"
            (click)="onOpenCountryPicker()" />
        </ng-container>
        <ng-container *ngIf="!countryFormControl.value?.flag">
          <div class="flag" aria-hidden="true"></div>
        </ng-container>
        <span class="fixed-space-8" aria-hidden="true"></span>
        <input
          data-clarity-unmask
          #countryField
          type="tel"
          class="phone-country-code"
          id="tel-country-code"
          name="tel-country-code"
          [attr.aria-label]="t('Country Code')"
          [formControl]="autocompleteCountryFormControl"
          maxlength="4"
          minlength="2"
          autocomplete="tel-country-code"
          inputmode="tel"
          (blur)="onBlur()"
          (focus)="onFocus()" />
      </div>
      <span class="fixed-space-8" aria-hidden="true"></span>

      <!-- Phone Field -->
      <input
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
        data-clarity-unmask
        #field
        type="tel"
        class="field"
        name="tel-national"
        inputmode="tel"
        autocomplete="tel-national"
        [formControl]="formControl"
        [id]="id || generatedId"
        [placeholder]="placeholder || (generatedPlaceholder$ | async) || ''"
        [tabindex]="focusIndex"
        (blur)="onBlur()"
        (focus)="onFocus()" />
    </div>
    <span class="error-label" *ngIf="error && initialized">{{ t(error) }}</span>
  </section>

  <!-- Placeholder -->
  <div class="skeleton popsy-text-field" aria-hidden="true" *ngIf="loading === true">
    <popsy-skeleton class="skeleton label"></popsy-skeleton>
    <popsy-skeleton class="field-skeleton"></popsy-skeleton>
  </div>
</ng-container>
